import React, { FC, useContext, useMemo } from "react";
import { Drawer } from "../planning/Drawer";
import { usePlanner } from "../planning/PlannerContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo, faTimes, faWarning } from "@fortawesome/free-solid-svg-icons";
import { WorkorderOverview } from "../planning/WorkorderOverview";
import { usePersistentState } from "@traas/lib/src/util/usePersistentState";
import { SingleSelectCalendar } from "@traas/lib/src/components/form/MultiSelectCalendar";
import { Toggle } from "@traas/lib/src/components/form/Toggle";
import { OnlineEmployeesIndicator } from "@traas/planning/src/realtime/OnlineEmployeesIndicator";

export const Werkbonnen: FC = () => {
  const [compact, setCompact] = usePersistentState<boolean>("werkbonnen_compact", false);
  return (
    <main className={"select-none flex-1 flex items-stretch"}>
      <div className={"flex-1 relative h-[calc(100%-0rem)]"}>
        <div className={"overflow-y-scroll absolute inset-0"}>
          <PlanningNav compact={compact} setCompact={setCompact} />
          <div className={""}>
            {" "}
            {/* 5rem compensates the h-20 on the PlanningNav */}
            <div className={"px-6 py-8"}>
              <WorkorderOverview compact={compact} />
            </div>
          </div>
        </div>
      </div>
      <Drawer />
    </main>
  );
};

const PlanningNav: FC<{ compact: boolean; setCompact: (newVal: boolean) => void }> = (props) => {
  const { setDay, day, notifications, dismissNotification } = usePlanner();
  return (
    <nav className={"flex relative justify-between items-start shadow-xs px-6 bg-white border-b border-slate-100"}>
      <h1 className={"h-20 hidden xl:flex items-center text-2xl font-bold mr-8"}>Werkbonnen</h1>
      <div className={"flex-1 py-3"}>
        <SingleSelectCalendar
          taskDate={day}
          selected={day}
          setSelected={(d) => {
            if (d !== null) {
              setDay(d as Date);
            }
          }}
        />
      </div>
      <div className={"h-20 flex items-center"}>
        <OnlineEmployeesIndicator />
        <div>
          <Toggle label={"Compacte weergave"} value={props.compact} onChange={props.setCompact} />
        </div>
        <div className={"absolute top-full right-4 z-50 w-72 flex flex-col items-stretch"}>
          {notifications.map((n, i) => {
            return (
              <div
                key={i}
                className={"border border-slate-200 bg-white rounded-lg shadow-sm p-2 flex items-stretch m-2 mb-0"}
              >
                <div className={"flex items-center"}>
                  {n.level === "info" && (
                    <div
                      className={"h-9 w-9 mr-3 rounded-full bg-blue-200 text-blue-800 flex items-center justify-center"}
                    >
                      <FontAwesomeIcon icon={faInfo} />
                    </div>
                  )}
                  {n.level === "warning" && (
                    <div
                      className={
                        "h-9 w-9 mr-3 rounded-full bg-amber-200 text-amber-800 flex items-center justify-center"
                      }
                    >
                      <FontAwesomeIcon icon={faWarning} />
                    </div>
                  )}
                  {n.level === "error" && (
                    <div
                      className={"h-9 w-9 mr-3 rounded-full bg-red-200 text-red-800 flex items-center justify-center"}
                    >
                      <FontAwesomeIcon icon={faWarning} />
                    </div>
                  )}
                </div>

                <div className={"flex-1"}>
                  <h2 className={"text-slate-900 font-medium text-base"}>{n.title}</h2>
                  <p className={"text-slate-600 text-sm text-ellipsis"}>{n.description}</p>
                </div>
                <div className={""}>
                  <button
                    className={
                      "h-5 w-5 rounded-sm hover:bg-slate-200 text-slate-600 hover:text-red-800 flex items-center justify-center"
                    }
                    onClick={() => dismissNotification(n)}
                  >
                    <FontAwesomeIcon icon={faTimes} />
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </nav>
  );
};
